import { cn } from "@/lib/utils";

const BAR_MAP = {
  healthy: "bg-status-healthy",
  low: "bg-status-low",
  critical: "bg-status-critical",
  "in-transit": "bg-status-in-transit",
  brand: "bg-primary",
  muted: "bg-border",
};

export function KPICard({ label, value, sublabel, tone = "muted", icon: Icon, testId }) {
  return (
    <div
      data-testid={testId}
      className="surface relative overflow-hidden p-6 md:p-8 group transition-colors hover:bg-card/80"
    >
      <div className="flex items-start justify-between gap-4">
        <span className="label-eyebrow">{label}</span>
        {Icon && <Icon className="w-5 h-5 text-muted-foreground/60 group-hover:text-foreground transition-colors" />}
      </div>
      <div className="mt-6 kpi-value leading-none pr-2 break-words">{value}</div>
      {sublabel && (
        <div className="mt-3 text-sm text-muted-foreground font-medium">{sublabel}</div>
      )}
      <span className={cn("absolute left-0 bottom-0 h-1 w-full", BAR_MAP[tone])} />
    </div>
  );
}
